module.exports = __webpack_public_path__ + "img/edit-discussion.f8ade209.svg";